import { createFileRoute } from '@tanstack/react-router';

import { BulkApprovedVendorListImporter } from '@/areas/suppliers/Suppliers/BulkApprovedVendorListImporterPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/suppliers/line-card-rules/importer')({
    staticData: {
        access: { permissions: ['view:supplier', 'edit:organization_settings'] },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <BulkApprovedVendorListImporter />;
}
